export enum TransakceStav {
    Chyba = "Chyba",
    Založeno = "Založeno",
    Zrušeno = "Zrušeno",
    ČekáNaZaplacení = "Čeká na zaplacení",
    Zaplaceno = "Zaplaceno"
}